import React, { useState } from 'react'
import { Divider, Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import cx from 'classnames'
import { InlineEdit } from '../../../../../../../../../../components/InlineEdit/InlineEdit'
import { useHoverOpacity } from '../../../../../../../../../../hooks/useHoverOpacity'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    hidden: {
      display: 'none',
    },
    stat: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  })
)

interface Props {
  name: string
  value: number
  editable?: boolean
  onEdit?: (value: string) => void
}

export const WeaponProfItem: React.FC<Props> = ({ name, value, editable, onEdit }) => {
  const classes = useStyles()
  const [editMode, setEditMode] = useState<boolean>()
  const { onMouseEnter, onMouseLeave, hoverClass } = useHoverOpacity()

  return (
    <>
      <div
        className={cx(classes.stat, hoverClass)}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div>{name}</div>
        <div className={classes.stat}>
          {editMode && editable && (
            <InlineEdit
              defaultValue={String(value)}
              onEdit={v => {
                setEditMode(false)
                onEdit && onEdit(v)
              }}
              onCancel={() => setEditMode(false)}
            />
          )}
          <span
            onClick={() => editable && setEditMode(true)}
            className={cx(editMode && classes.hidden)}
          >
            {value}
          </span>
        </div>
      </div>
      <Divider />
    </>
  )
}
